/* modalDirtyGuard — společný strážce pro „klik vedle okna zavře modal".
 *
 * PROBLÉM (nahlášeno 8/2026): backdrop volal onClose() bez ptaní. Poradce vyplnil
 * 12 polí nové smlouvy, omylem kliknul 20 px vedle okna → modal se zavřel, všechno
 * pryč, bez varování a bez konceptu. Dirty-guard klientské složky
 * (lib/clientFolderGuard.js) tyhle formuláře nehlídá — sleduje jen kontaktní kartu.
 *
 * ŘEŠENÍ: zavřít MLČKY, když není co ztratit (prázdný formulář → žádné otravné
 * ptaní), a zeptat se jen tehdy, když poradce něco vyplnil.
 *
 * ZÁMĚRNĚ hlídáme jen backdrop. Křížek a „Zrušit" jsou vědomé akce — tam poradce
 * zavřít CHCE a další dialog by jen otravoval.
 */

/** Je co ztratit? Dostane hodnoty, které poradce sám vyplnil.
 *  Čísla se ignorují: pole jako pravděpodobnost (50) nebo index fáze mají
 *  přednastavenou hodnotu, kterou nikdo nezadal — samy o sobě „rozepsáno" neznamenají. */
export function jeRozepsano(hodnoty = []) {
  if (!Array.isArray(hodnoty)) return false;
  return hodnoty.some((v) => {
    if (v === null || v === undefined || v === false || v === true) return false;
    if (typeof v === "string") return v.trim() !== "";
    if (typeof v === "number") return false;
    if (Array.isArray(v)) return v.length > 0;
    return false;
  });
}

/** Text dotazu. Dvojjazyčně (cs/sk) — SK varianta je povinná, viz CLAUDE.md. */
export function zpravaZahozeni(lang) {
  return lang === "sk"
    ? "Máš rozpísaný formulár. Zavrieť a zahodiť vyplnené údaje?"
    : "Máš rozepsaný formulář. Zavřít a zahodit vyplněné údaje?";
}

/** Vrátí handler na backdrop modalu.
 *  Dirty se pozná dvěma způsoby — použij ten, který dává v daném modalu smysl:
 *    • `hodnoty` = pole vyplněných hodnot (formulář, který startuje prázdný),
 *    • `zmeneno` = boolean (formulář, který startuje PŘEDVYPLNĚNÝ, např. editace
 *      existující smlouvy — tam se musí porovnávat s výchozím stavem, jinak by se
 *      modal ptal pokaždé, i když poradce jen nakoukl a nic nezměnil).
 *  `onClose` = původní zavírací callback.
 *  `potvrdit` jde podstrčit z testu (jinak window.confirm; když chybí, zavře se). */
export function zavriNaPozadi({ hodnoty, zmeneno, onClose, lang, potvrdit } = {}) {
  return (e) => {
    // Klik uvnitř okna nezavírá. Panely sice mají stopPropagation, ale spoléhat
    // se na to napříč čtyřmi modaly je křehké — tohle je pojistka navíc.
    if (e && e.target !== e.currentTarget) return;
    const dirty = zmeneno === undefined ? jeRozepsano(hodnoty) : !!zmeneno;
    if (!dirty) { onClose?.(); return; }
    const ptat = potvrdit
      || ((zprava) => (typeof window !== "undefined" && typeof window.confirm === "function"
        ? window.confirm(zprava)
        : true));
    if (ptat(zpravaZahozeni(lang))) onClose?.();
  };
}
